<template>
  <div class="productPage">
    <h2>
      <!-- 热门产品 -->
      <div>
        <img :src="hrefurl+'/public/home/title%26bg/homeProducts_en.png'" alt="" />
      </div>
    </h2>
    <div class="product">
      <div>
        <div class="scroll-content" ref="scrollContent">
          <div class="scroll-slide" v-for="(item,index) in arrList" :key="index" >
            <p @click="isDetails(item)">{{item.proname_en}} 
            </p>
            <div class="bsImg1" @click="isDetails(item)">
              <img :src="item.img_url" alt="" />
            </div>
            <div class="bsImg2" @click.stop="exhjump(item)">
              {{item.corpname_en}}
            </div>
          </div>
          <div class="scroll-slide" v-for="(item1,index) in arrList" :key="arrList.length+index">
            <p @click="isDetails(item1)">{{item1.proname_en}} 
            </p>
            <div class="bsImg1" @click="isDetails(item1)">
              <img :src="item1.img_url" alt="" />
            </div>
            <div class="bsImg2" @click="exhjump(item1)">
              {{item1.corpname_en}}
            </div>
          </div>
        </div>
        <span class="scroll-button scroll-button-prev" @click="prev"><img class="img1" :src="hrefurl+'/public/exhibit/pageLeft.png'" alt="" /></span>
        <span class="scroll-button scroll-button-next" @click="next"><img class="img2" :src="hrefurl+'/public/exhibit/pageLeft.png'" alt="" /></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { reqProListAd } from "../../../api";
export default {
  data(){
    return{
      arrList:[]
    }
  },
  mounted(){
    
    this.num=0
    this.init()
  },
  methods:{
    async init(){
      const response = await reqProListAd()
      if (response.code*1==1) {
        this.arrList = response.resilt
        this.width = this.arrList.length*228*2
        this.$refs.scrollContent.style.width = this.width+"px"
      }else{
        this.err(this,"请求失败，请稍后后重试。。。")
      }
    },

    prev(){
      if(this.num>=0){
        this.num=-this.width/2
        this.$refs.scrollContent.style.transform="translateX("+this.num+"px)"
        this.$refs.scrollContent.style.transition="all 0s"
      }
      setTimeout(()=>{
        this.betterScroll(228)
      },30)
    },

    next(){
      if(Math.abs(this.num)>=this.width-1140){
        this.num=1140-this.width/2
        this.$refs.scrollContent.style.transform="translateX("+this.num+"px)"
        this.$refs.scrollContent.style.transition="all 0s"
      }
      setTimeout(()=>{
        this.betterScroll(-228)
      },30)
    },

    betterScroll(amount){
      this.num=amount+this.num
      this.$refs.scrollContent.style.transform="translateX("+this.num+"px)"
      this.$refs.scrollContent.style.transition="all .5s"
    },
    
    isDetails(item){// 展品详情页跳转
      if (this.jump(this)) {
        this.$router.push('/exhibit/details/'+item.id+'/'+item.ocid)
      }
      
    },

    exhjump(item){// 展商详情跳转
      if (this.jump(this)) {
        this.$router.push('/exhibitor/details/'+item.corpid+"/"+item.ocid)
      }
    },
  },
  computed:{
    ...mapState({
      isLogin:state=>state.user.isLogin,
    }),
  }

}
</script>

<style  scoped>
  .productPage{
    
  }
  .product{
    max-width: 1200px;
    height: 312px;
    position: relative;
    margin: 0 auto;
    background-color: #f1f1ef;
    padding: 10px 0;
    border: 1px solid #008baf;
  }
  h2{
    text-align: center;
    padding: 70px 0 50px 0;
    font-size: 40px;
    color: #494c4d;
  }
  h2>div{
    /* width: 300px; */
    height: 80px;
    overflow: hidden;
    margin: 0 auto;
  }
  h2>div img{
    width: auto;
    height: auto;
  }
  .product>div{
    width: calc(100% - 84px);
    height: 100%;
    margin: auto;
    overflow: hidden;
  }
  .scroll-content{
    display: flex;
    flex-wrap: nowrap;
    height: 100%;
  }
  .scroll-slide{
    width: 204px;
    height: 100%;
    margin-right: 24px;
    background-color: white;
    text-align: center;
    padding: 5px;
    cursor: pointer;
    border-radius: 4px;
    box-shadow: 0 4px 15px 0 rgba(40, 44, 53, 0.06), 0 2px 2px 0 rgba(40, 44, 53, 0.08);
  }
  .scroll-slide>p{
    font-size: 18px;
    color: #333333;
    padding: 10px 0;
    height: 76px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 600;
    font-family: 'FjallaOne-Regular';
  }
  .scroll-slide>p:hover{
    color: #008baf;
  }
  .bsImg1{
    width: 194px;
    height: 155px;
  }
  .bsImg2{
    width: 194px;
    height: 55px;
    line-height: 55px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    font-family: 'FjallaOne-Regular';
  }
  .bsImg2:hover{
    color: #008baf;
  }
  .scroll-slide img{
    vertical-align: bottom;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    transition: opacity 150ms linear;
    user-select: none;
    width: 100%;
  }
  .scroll-slide .qyimg{
    border-top: 4px solid #ffffff;
    padding-top: 2px;
  }
  .scroll-slide img:hover {
    opacity: .5;
  }
  .scroll-button{
    position: absolute;
    width: 40px;
    height: 86px;
    top: 50%;
    transform: translateY(-50%);
    line-height: 60px;
    text-align: center;
    cursor: pointer;
    font-size: 32px;
  }
  .scroll-button-prev{
    left: 0;
  }
  .scroll-button-next{
    right: 0;
  }
  .img1,
  .img2{
    cursor: pointer;
    user-select: none;
  }
  .img2{
    transform: rotateY(180deg);
  }
</style>